import { ckmeans } from 'simple-statistics';

export class ClassificationUtils {
  public static classifyCKMeans(data: number[], nbBreaks: number): { minValue: number; maxValue: number; population: number }[] {
    if (data.length < nbBreaks) {
      // build a break for each value
      return data.map((value) => ({
        minValue: value,
        maxValue: value,
        population: 1,
      }));
    }
    const ckmeans_breaks = ckmeans(data, nbBreaks);
    const breaks = ckmeans_breaks.map((ckb, idx) => {
      let population = ckb.length;
      let a_break = {
        minValue: ckb[0],
        maxValue: ckb[population - 1],
        population,
      };

      return a_break;
    });
    return breaks;
  }
}
